import { useState } from 'react';
import { api } from '../lib/api';

interface TrialBannerProps {
  trialEndsAt: string | null;
  onDismiss: () => void;
}

export default function TrialBanner({
  trialEndsAt,
  onDismiss,
}: TrialBannerProps) {
  const [isLoading, setIsLoading] = useState(false);

  const daysLeft = trialEndsAt
    ? Math.ceil(
        (new Date(trialEndsAt).getTime() - Date.now()) /
          (1000 * 60 * 60 * 24)
      )
    : null;

  async function handleSubscribe() {
    setIsLoading(true);
    try {
      const { url } = await api.billing.checkout('pro');
      window.location.href = url;
    } catch {
      setIsLoading(false);
    }
  }

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-sm px-4 py-3 flex items-start gap-3">
      <span className="text-blue-500 shrink-0 mt-0.5">
        ℹ
      </span>
      <p className="text-sm text-blue-800 leading-relaxed flex-1">
        <strong>Free trial active.</strong>{' '}
        {daysLeft !== null && daysLeft > 0 ? (
          <>
            Your trial ends in{' '}
            <strong>
              {daysLeft} day{daysLeft !== 1 ? 's' : ''}
            </strong>
            {trialEndsAt && (
              <>
                {' '}
                (
                {new Date(trialEndsAt).toLocaleDateString()}
                )
              </>
            )}
            . Subscribe to keep full editing access after it
            expires.
          </>
        ) : (
          <>
            Subscribe to keep full editing access to this
            calendar.
          </>
        )}
      </p>
      <div className="flex items-center gap-2 shrink-0">
        <button
          onClick={handleSubscribe}
          disabled={isLoading}
          className="font-mono text-xs font-semibold text-blue-700 border border-blue-300 rounded-sm px-2.5 py-1 hover:bg-blue-100 transition-colors disabled:opacity-50"
        >
          {isLoading ? 'Loading…' : 'Subscribe →'}
        </button>
        <button
          onClick={onDismiss}
          aria-label="Dismiss"
          className="text-blue-400 hover:text-blue-700 transition-colors text-lg leading-none"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
